import { html, type TemplateResult } from 'lit';

export function shellOfflineUpdateBannerTemplate(onGoToUpdate: () => void): TemplateResult {
  return html`
    <div
      class="shrink-0 border-b border-[color:var(--md-sys-color-primary)] bg-[color:var(--md-sys-color-primary-container)] px-4 py-3 text-sm text-[color:var(--md-sys-color-on-primary-container)]"
      role="status"
      aria-live="polite"
      data-offline-update-banner
    >
      <div class="mx-auto flex max-w-5xl flex-col gap-3 sm:flex-row sm:items-center sm:justify-between">
        <p class="font-medium">
          Hay una versión nueva de la aplicación. Abra Actualizar para limpiar la caché y cargar la versión reciente.
        </p>
        <button
          type="button"
          class="md-sys-ripple shrink-0 rounded-[var(--md-shape-corner-medium)] bg-[color:var(--md-sys-color-primary)] px-4 py-2.5 text-sm font-medium text-[color:var(--md-sys-color-on-primary)]"
          @click=${onGoToUpdate}
        >
          Ir a Actualizar
        </button>
      </div>
    </div>
  `;
}
